import React from "react";
import './Loader.css';
import gaetLogo from "../assets/GAET_Trust_Logo.png";

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-wrapper">
        <img loading="lazy" src={process.env.PUBLIC_URL + "/images/logo.png" || gaetLogo} className="loader-image" />
      </div>
    </div>
  );
};

export default Loader;
